export default "\n截至 2025 年，开发者文档已上线说明如何为平台准备新语料库。我们目前正在完善添加单首曲目的流程。\n\n在此期间，如需添加新曲目和/或讨论 Dezrann 的使用，请[联系我们](mailto:contact@dezrann.net)。";